import { vec2, vec3 } from 'gl-matrix'
import Node from '../abstract/node'

// Loaders
import MeshLoader from '@/glxp/loader/binaryLoader'
import AnimLoader from '@/glxp/loader/animationLoader'

// Entities
import Plane from '../entities/plane'
import Mesh from '../entities/mesh'
import Leaf from '../entities/leafMesh'
import Water from '../entities/water'
import Plateform from '../entities/plateform'
import SkinedMesh from '../entities/skining/skinedMesh'
import HandAnimator from '../entities/handAnimator'
import Background from '../entities/background'
import Catmull from '../utils/catmull'
import DebugLine from '../entities/LineDebug'


const _VEC2 = vec2.create()


class LoadingManager {
    constructor(scene){
        this.scene = scene
    }

    getIntroLoadables(){
        let loadables = []
        let sceneUrl
        sceneUrl = "glxp/models/Intro_Scene"
        loadables.push(new MeshLoader(sceneUrl + ".json", sceneUrl + ".bin").then((objs) => {
            for (let i = 0; i < objs.length; i++) {
                const element = objs[i];
                if (element.name == "Camera") {
                    this.scene.camera.node.position = vec3.clone(element.translate)
                    this.scene.camera.node.rotation = vec3.clone(element.rotation)
                    this.scene.camera.node.initialPosition = vec3.clone(element.translate)
                    this.scene.camera.node.needUpdate = true
                    this.scene.cameraPosition = vec3.clone(element.translate)
                    this.scene.cameraPositionTarget = vec3.clone(element.translate)
                    this.scene.cameraTargets[4] = vec3.clone(element.translate)
                }

                if (element.type == "triangle") {
                    let mesh
                    if (element.name.includes("Leave")) {
                        mesh = new Leaf(this.scene, element, "unlit-leaf", element.material)
                    } else if (element.name.includes("Background")) {
                        this.scene.background = new Background(this.scene, element, "background", element.material)
                        this.scene.background.depthTest = false
                        this.scene.background.depthWrite = false
                        this.scene.root.addChildNode(this.scene.background.node)
                        continue
                    } else if (element.name.includes("Butterfly-mesh")) {
                        mesh = new Mesh(this.scene, element, "butterfly", element.material)
                        mesh.mask = 1.5
                        mesh.depthWrite = false
                    } else if (element.name.includes("Floor")) {
                        mesh = new Water(this.scene, element, "water", element.material)
                        this.scene.water = mesh
                    } else {

                        mesh = new Mesh(this.scene, element, "unlit", element.material)
                    }
                    mesh.parent = element.parent

                    this.scene.root.addChildNode(mesh.node)
                    this.scene.meshes.push(mesh)
                } else if (element.type == "Null" && element.name !== "Camera") {
                    let node = new Node()
                    node.name = element.name
                    node.position = vec3.clone(element.translate)
                    node.rotation = vec3.clone(element.rotation)
                    node.scale = vec3.clone(element.scale)

                    if (element.name.includes("Target-Intro")) {
                        this.scene.cameraTargetsLookat[4] = vec3.clone(element.translate)
                    }

                    this.scene.root.addChildNode(node)
                    this.scene.nodes.push(node)
                } else if (element.type == "line"){

                    let points = []
                    for (let i = 0; i < element.vertices.length / 3; i++) {
                        points.push([
                            element.vertices[i * 3 + 0],
                            element.vertices[i * 3 + 1],
                            element.vertices[i * 3 + 2],
                        ])
                    }

                    let spline = new Catmull(points)
                    spline.node.position = vec3.clone(element.translate)
                    spline.node.rotation = vec3.clone(element.rotation)
                    spline.node.scale = vec3.clone(element.scale)
                    // this.scene.root.addChildNode(spline.node)
                    // this.scene.meshes.push(new DebugLine(this.scene, spline.getPointsUniform(3000)))
                    spline.generate()
                    spline.name = element.name
                    this.scene.splines.push(spline)


                }

            }

            for (let i = 0; i < this.scene.meshes.length; i++) {
                if (this.scene.meshes[i].parent) {
                    let parentName = this.scene.meshes[i].parent
                    let parentNode = this.scene.getNode(parentName)
                    parentNode.addChildNode(this.scene.meshes[i].node)
                    this.scene.meshes[i].node.needUpdate = true
                }
            }

    }))

        return loadables
    }

    getLoadables(){

        let loadables = []
        let sceneUrl
        sceneUrl = "glxp/models/Scene_1"
        loadables.push(new MeshLoader(sceneUrl + ".json", sceneUrl + ".bin").then((objs) => {
        for (let i = 0; i < objs.length; i++) {
            const element = objs[i];
            if (element.name == "Camera") {
                this.scene.cameraTargets[0] = vec3.clone(element.translate)
            }

            if (element.type == "triangle") {
                let mesh
                if (element.name.includes("Leave")) {
                    mesh = new Leaf(this.scene, element, "unlit-leaf", element.material, "Scene_1")
                } else {
                    mesh = new Mesh(this.scene, element, "unlit", element.material, "Scene_1")
                }
                mesh.parent = element.parent

                if (element.name.includes("Nenuphar")) {
                    mesh.rotSeed = (Math.max(Math.random()+1)*4) - 1
                    mesh.initialPosition = vec3.clone(element.translate)
                    this.scene.nenuphars.push(mesh)
                }

                if (element.name.includes("Sun")) {
                    mesh.node.rotation[2] = Math.PI / 3
                    mesh.section = "global"
                }

                if (element.name.includes("Shadow-Plateform")) {
                    mesh.opacity = 0
                    mesh.depthTest = false
                    mesh.depthWrite = false
                    this.scene.plateformShadow = mesh
                }

                this.scene.root.addChildNode(mesh.node)
                this.scene.meshes.push(mesh)
            } else if(element.type == "Null" && element.name !== "Camera"){
                let node = new Node()
                node.name = element.name
                node.position = vec3.clone(element.translate)
                node.rotation = vec3.clone(element.rotation)
                node.scale = vec3.clone(element.scale)

                if (element.name == "Target") {
                    this.scene.cameraTargetsLookat[0] = vec3.clone(element.translate)
                }
                this.scene.root.addChildNode(node)
                this.scene.nodes.push(node)
            }

        }

        for (let i = 0; i < this.scene.meshes.length; i++) {
            if (this.scene.meshes[i].parent) {
                let parentName = this.scene.meshes[i].parent
                let parentNode = this.scene.getNode(parentName)
                parentNode.addChildNode(this.scene.meshes[i].node)
                this.scene.meshes[i].node.needUpdate = true
            }
        }

        }))

        this.scene.handsRootNode = new Node()
        this.scene.root.addChildNode(this.scene.handsRootNode)
        sceneUrl = "glxp/models/Hand"
        loadables.push(new MeshLoader(sceneUrl + ".json", sceneUrl + ".bin").then((objs) => {
            this.scene.handsRigs = []
            // for (let k = 0; k < 1; k++) {
            for (let k = 0; k < 2; k++) {
                let handNodes = []
                for (let i = 0; i < objs.length; i++) {
                    const element = objs[i];
                    if (element.type == "Null") {
                        let node = new Node();
                        node.position = vec3.clone(element.translate);
                        node.rotation = vec3.clone(element.rotation);
                        node.scale = vec3.clone(element.scale);
                        node.name = element.name;
                        node.sid = element.sid;
                        node._parent = element.parent;
                        handNodes.push(node);
                    }
                }

                for (let i = 0; i < handNodes.length; i++) {
                    let parentName = handNodes[i]._parent;
                    if (parentName) {
                        for (let j = 0; j < handNodes.length; j++) {
                            if (handNodes[j].name == parentName) {
                                handNodes[j].addChildNode(handNodes[i]);
                            }
                        }
                    }
                }


                for (let i = 0; i < handNodes.length; i++) {
                    handNodes[i].needUpdate = true;
                    handNodes[i].getMatrix();
                }

                let mesh = new SkinedMesh(this.scene, objs[1], objs[0], objs, "HandRig", handNodes);
                mesh.active = false

                handNodes[1].rotation[0] += 0.75
                handNodes[1].rotation[1] -= 0.1
                handNodes[1].rotation[2] -= 0.2
                handNodes[1].needUpdate = true
                let handRoot = new Node()
                handRoot.addChildNode(handNodes[0])
                this.scene.handsRootNode.addChildNode(handRoot)

                handRoot.scale = vec3.fromValues(0, 0, 0)
                handRoot.position = vec3.fromValues(0, 30, -500)

                this.scene.handsRigs.push({
                    mesh: mesh,
                    rootNode: handRoot,
                    nodes: handNodes,
                    animator: new HandAnimator(this.scene, handNodes, handRoot, mesh)
                })
            }

        }))

        sceneUrl = "glxp/models/Scene_2"
        this.scene.plateformMeshes = []
        loadables.push(new MeshLoader(sceneUrl + ".json", sceneUrl + ".bin").then((objs) => {
            this.scene.plateformRootNode = new Node()
            this.scene.plateformRootNode.position[2] = -100
            this.scene.root.addChildNode(this.scene.plateformRootNode)
            for (let i = 0; i < objs.length; i++) {
                const element = objs[i];
                if (element.name == "Camera") {
                    this.scene.cameraTargets[1] = vec3.clone(element.translate)
                }
                if (element.type == "triangle") {
                    let mesh
                    if (element.name.includes("Top_Rock_Plateform") || element.name.includes("Bottom_Rock_Plateforme")) {
                        mesh = new Plateform(this.scene, element, "plateform", element.material)
                        this.scene.plateformMeshes.push(mesh)
                        mesh.active = false
                        mesh.node.forceUpdate = true

                    } else if(element.name.includes("Plane")) {
                        mesh = new Mesh(this.scene, element, "plane", element.material, "Scene_2")
                    }
                     else {
                        mesh = new Mesh(this.scene, element, "unlit", element.material, "Scene_2")
                    }
                    mesh.parent = element.parent
                    if (element.name.includes("Cloud")) {
                        mesh.depthTest = false
                    }

                    if (element.name.includes("Plane")) {
                        mesh.section = "global"
                        // console.log(mesh)
                    }

                    if (element.name.includes("Top_Rock_Plateform")) {
                        mesh.opacity = 0
                        mesh.mask = 1
                    }

                    if (element.name.includes("Cloud_Front")) {
                        mesh.mask = 2
                    }

                    if (element.name.includes("Bottom_Rock_Plateforme")) {
                        mesh.opacity = 0.5
                        mesh.side = "front"
                        mesh.mask = 1
                        mesh.node.scale[1] = 0
                    }

                    if (element.name.includes("Cloud_Transition")) {
                        mesh.mask = 3
                    }

                    this.scene.root.addChildNode(mesh.node)
                    this.scene.meshes.push(mesh)

                } else if(element.type == "Null" && element.name !== "Camera"){
                    let node = new Node()
                    node.name = element.name
                    node.position = vec3.clone(element.translate)
                    node.rotation = vec3.clone(element.rotation)
                    node.scale = vec3.clone(element.scale)
                    node.forceUpdate = true

                    if (element.name == "Target") {
                        this.scene.cameraTargetsLookat[1] = vec3.clone(element.translate)
                    }

                    if (element.name.includes("Rock")) {
                        node.position[1] = 0
                        this.scene.plateformRootNode.addChildNode(node)
                    } else {
                        this.scene.root.addChildNode(node)
                    }

                    this.scene.nodes.push(node)
                }

            }

            for (let i = 0; i < this.scene.plateformMeshes.length; i++) {
                let parentName = this.scene.plateformMeshes[i].parent;
                if (parentName) {
                    for (let j = 0; j < this.scene.nodes.length; j++) {
                        if (this.scene.nodes[j].name == parentName) {

                            this.scene.nodes[j].addChildNode(this.scene.plateformMeshes[i].node)
                        }
                    }
                }
            }
        }))

        sceneUrl = "glxp/models/Scene_3"
        loadables.push(new MeshLoader(sceneUrl + ".json", sceneUrl + ".bin").then((objs) => {
            let rockBackMeshes = []
            let rockFrontMeshes = []

            for (let i = 0; i < objs.length; i++) {
                const element = objs[i];
                if (element.name == "Camera") {
                    this.scene.cameraTargets[2] = vec3.clone(element.translate)
                    this.scene.cameraTargets[3] = vec3.clone(element.translate)
                    this.scene.cameraTargets[3][1] += 800
                }
                if (element.name == "Target") {
                    this.scene.cameraTargetsLookat[2] = vec3.clone(element.translate)
                    this.scene.cameraTargetsLookat[3] = vec3.clone(element.translate)
                    this.scene.cameraTargetsLookat[3][1] += 800
                }

                if (element.type == "triangle") {
                    let mesh
                    mesh = new Mesh(this.scene, element, "unlit", element.material, "Scene_3")
                    this.scene.meshes.push(mesh)

                    if (element.name.includes("Meteorites-Back")) {
                        rockBackMeshes.push(mesh)
                        mesh.node.initialPosition = vec3.clone(element.translate)
                        mesh.node.seeds = [Math.random(), Math.random(), Math.random()]
                        mesh.mask = 1
                        mesh.useScreenSpaceNoise = false
                    } else if (element.name.includes("Meteorite-Front")) {
                        rockFrontMeshes.push(mesh)
                        mesh.node.initialPosition = vec3.clone(element.translate)
                        mesh.node.seeds = [Math.random(), Math.random(), Math.random()]
                        mesh.depthTest = false
                        mesh.depthWrite = false
                        mesh.mask = 2
                        mesh.useScreenSpaceNoise = false
                    } else if (element.name.includes("Planet")) {
                        this.scene.root.addChildNode(mesh.node)
                    }

                }
            }

            for (let i = 0; i < objs.length; i++) {
                const element = objs[i];
                if (element.name == "Front-Rocks") {
                    let node = new Node()
                    node.name = element.name
                    node.position = vec3.clone(element.translate)
                    node.rotation = vec3.clone(element.rotation)
                    node.scale = vec3.clone(element.scale)
                    this.scene.root.addChildNode(node)
                    this.scene.nodes.push(node)
                    for (let j = 0; j < rockFrontMeshes.length; j++) {
                        node.addChildNode(rockFrontMeshes[j].node)
                    }
                }
                if (element.name == "Back-Rocks") {
                    let node = new Node()
                    node.name = element.name
                    node.position = vec3.clone(element.translate)
                    node.rotation = vec3.clone(element.rotation)
                    node.scale = vec3.clone(element.scale)
                    this.scene.root.addChildNode(node)
                    this.scene.nodes.push(node)
                    for (let j = 0; j < rockBackMeshes.length; j++) {
                        node.addChildNode(rockBackMeshes[j].node)
                    }
                }
            }
        }))


        // Animation Loading
        this.scene.handsAnimations = {}
        sceneUrl = "glxp/models/Hand_idle_animation_001_anims"
        loadables.push(new AnimLoader(sceneUrl + ".json", sceneUrl + ".bin").then((objs) => {
            this.scene.handsAnimations["idle-01"] = objs
        }))
        sceneUrl = "glxp/models/Hand_scisors_animation_001_anims"
        loadables.push(new AnimLoader(sceneUrl + ".json", sceneUrl + ".bin").then((objs) => {
            this.scene.handsAnimations["scisors"] = objs
        }))
        sceneUrl = "glxp/models/Hand_paper_animation_001_anims"
        loadables.push(new AnimLoader(sceneUrl + ".json", sceneUrl + ".bin").then((objs) => {
            this.scene.handsAnimations["paper"] = objs
        }))
        sceneUrl = "glxp/models/Hand_rock_animation_001_anims"
        loadables.push(new AnimLoader(sceneUrl + ".json", sceneUrl + ".bin").then((objs) => {
            this.scene.handsAnimations["rock"] = objs
        }))
        sceneUrl = "glxp/models/Hand_shifumi_animation_001_anims"
        loadables.push(new AnimLoader(sceneUrl + ".json", sceneUrl + ".bin").then((objs) => {
            this.scene.handsAnimations["shifumi"] = objs
        }))

        return loadables
    }
}

export default LoadingManager
